import api from "../api";

export const contact = async (formData: any): Promise<any> => {
  const { data } = await api.post("/v1/contact", formData);
  return data;
};
